import { Box, useTheme } from "@mui/material";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Text from "../../theme/text/Text";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import { downloadFile } from "../../../utils/downloadFile";

const MSelectLabel = ({ open, handleClose, labels, type, rowsPerLabel }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const openLabel = (label, index) => {
        if (type === "pdf") {
            const decodedData = atob(label);
            const arrayBuffer = new ArrayBuffer(decodedData?.length);
            const uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < decodedData.length; i++) {
                uint8Array[i] = decodedData.charCodeAt(i);
            }
            const blob = new Blob([uint8Array], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(blob);
            window.open(pdfUrl, '_blank');
        } else if (type === "link") {
            window.open(label, '_blank');
        } else if (type === "zpl") {
            downloadFile(URL.createObjectURL(new Blob([label], { type: 'text/plain' })), `label-${index + 1}.zpl`);
        }
    };

    return (
        <SHModal
            open={open}
            onClose={handleClose}
            title={t("select_label")}
            sx={{
                body: {
                    minWidth: 300,
                    maxWidth: 400
                }
            }}
        >
            <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                <Text>{t("multiple_documents_available")}</Text>
                {labels.map((label, index) => (
                    <Box key={index} sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                        <Shbutton
                            block
                            onClick={() => openLabel(label, index)}
                            color="primary"
                            variant="contained"
                        >
                            {t("document")} {index + 1}
                        </Shbutton>
                        {rowsPerLabel?.[index]?.map((row, rowIndex) => (
                            <Text key={rowIndex}>{row.amount}x {row.product?.sku} {row.product?.description}</Text>
                        ))}
                    </Box>
                ))}

            </Box>
        </SHModal>
    );
};

export default MSelectLabel;